import merge from 'lodash/merge';
import map from 'lodash/map';

function searchLocations(location) {
  const START = '^';
  const END = '$';
  const suburbGroup = '(?:(.*?))';
  const stateGroup = '(?:\\s(wa|nt|sa|qld|nsw|act|vic|tas|nz))';
  const postcodeGroup = '(?:\\s(\\d{4}))';
  const allRegex = `${START}${suburbGroup}?${stateGroup}?${postcodeGroup}?${END}`;
  const [, locality, subdivision, postcode] = new RegExp(allRegex, 'g').exec(location);
  const subdivisionObj = subdivision ? { subdivision } : {};
  const postcodeObj = postcode ? { postcode } : {};

  return merge({ locality: locality.trim() }, subdivisionObj, postcodeObj);
}

function getUrlLocations(location) {
  return decodeURIComponent(location).replace(/[\s-]+/g, ' ').split(',').filter(Boolean);
}

function parse(localities) {
  return localities ? getUrlLocations(localities).map(searchLocations) : undefined;
}

function escapeLocalityObject(firstLocalityObj) {
  const result = map(firstLocalityObj, (val, key) => ((key === 'locality') ? `${val},` : val)).join(' ');

  return escape(result);
}

export default { parse, escapeLocalityObject };
